document.addEventListener('DOMContentLoaded', function () {
    const globalDefaults = {
        type: 'loop',
        gap: '1.5rem',
        arrows: true,
        pagination: false,
        autoplay: true,
        interval: 7000,  // Default slide speed: 7 seconds
        pauseOnHover: true,   // pauses autoplay on mouse hover
        pauseOnFocus: true, 
    };

    const splideConfigs = {
        default: {
            perPage: 1,
            perMove: 1,
            autoplay: true,
            arrows: true
        },
        hero: {
            perPage: 1,
            perMove: 1,
            arrows: false
        },
        twocol: {
            perPage: 2,
            perMove: 1
        },
        threecol: {
            perPage: 3,
            perMove: 1
        },
        fourcol: {
            perPage: 4,
            perMove: 1,
            gap: '1rem',
            pagination: false
        },
        fivecol: {
            perPage: 5,
            perMove: 1,
            gap: '1px',
        },
        tworowsfourcol: {
            perPage: 4,
            perMove: 4,
            rows: 2,
            gap: '1rem'
        },
        ticker: {
            type: 'loop',
            focus: 'center',
            perPage: '5',
            perMove: '5',
            autoplay: true,
            arrows: false,
            pagination: false,
            gap: '1px',
            breakpoints: {
                768: {
                    autoScroll: {
                        speed: 0.5
                    }
                }
            }
        }
    };

    const commonBreakpoints = {
        640: {
            perPage: 1,
            gap: '1rem'
        },
        768: {
            perPage: 1,
            gap: '1rem'
        },
        1024: {
            perPage: 1,
            gap: '1rem'
        }
    };

    var sliders = document.querySelectorAll('.splide[data-splide-config]');
    sliders.forEach(function (sliderElement) {
        var configName = sliderElement.getAttribute('data-splide-config') || 'default';

        var config = Object.assign({}, globalDefaults, splideConfigs[configName] || splideConfigs.default);
        config.breakpoints = commonBreakpoints;

        var overridesJson = sliderElement.getAttribute('data-splide-overrides');
        if (overridesJson) {
            try {
                var overrides = JSON.parse(overridesJson);
                config = Object.assign({}, config, overrides);
            } catch (e) {
                console.error('Invalid Splide config overrides JSON:', overridesJson, e);
            }
        }

        var splide = new Splide(sliderElement, config);
        splide.mount();

        // Sync tabs only if this slider has associated tabs
        var sliderWrapper = sliderElement.closest('.wrapper-default');
        if (sliderWrapper) {
            var tabs = sliderWrapper.querySelectorAll('.slide-tab');

            if (tabs.length > 0) {
                // Tab click → go to slide
                tabs.forEach(function (tab) {
                    tab.addEventListener('click', function () {
                        var index = parseInt(tab.getAttribute('data-index'));
                        splide.go(index);
                    });
                });

                // Slide change → update active tab
                splide.on('moved', function (newIndex, prevIndex, destIndex) {
                    tabs.forEach(function (tab) {
                        tab.classList.remove('active');
                        if (parseInt(tab.getAttribute('data-index')) === newIndex) {
                            tab.classList.add('active');
                        }
                    });
                });
            }
        }
    });
});